import {SectionBgView} from '../../ui_canvas_engine/SectionBgView'
import {PIXI} from '@colonist/pixi'
import {GameColor} from '../../GameColor'
import {TextView} from '../../ui_canvas_engine/TextView'
import {GameFont} from '../../GameFont'
import {SpriteView} from '../../ui_canvas_engine/SpriteView'
import {UIGameConstants} from '../UIGameConstants'
import {TranslationObject} from '@colonist/i18n'

export interface GameEndChartColumnData {
    label: TranslationObject | number
    amount: number
    texture?: PIXI.Texture | undefined
}

export class UIGameEndChartColumnView extends SectionBgView {
    private readonly columnHeight: number
    private readonly columnWidth: number
    private readonly labelHeight: number
    private readonly columnCornerRadius: number
    private readonly columnData: GameEndChartColumnData

    private columnFillAmount: number

    constructor(x: number, y: number, w: number, h: number, radius: number, container: PIXI.Container,
                data: GameEndChartColumnData, largestYAxisNumber: number) {
        super(x, y, w, h, container)
        this.columnWidth = this.width
        this.columnHeight = this.height
        this.columnCornerRadius = radius
        this.labelHeight = this.columnHeight / 14
        this.columnData = data
        this.columnFillAmount = data.amount == 0 ? 0 : (data.amount / largestYAxisNumber) * this.columnHeight

        this.drawXAxisLabel()

        if(this.columnFillAmount == 0) return
        this.drawColumn()
    }

    private drawXAxisLabel() {
        const xAxisLabelY = this.columnHeight * 1.1

        if(this.columnData.texture == undefined) {
            this.drawXAxisLabelText(xAxisLabelY)
            return
        }
        this.drawXAxisLabelSprite(xAxisLabelY)
        const labelText: TranslationObject = typeof this.columnData.label === 'number' ? {key: 'strings:colonistCommon.utils.#buffer', options: {value: this.columnData.label}} : this.columnData.label
        this.setTip(labelText, [])
    }

    private drawXAxisLabelText(xAxisLabelY: number) {
        const labelText: TranslationObject = typeof this.columnData.label === 'number' ? {key: 'strings:colonistCommon.utils.#buffer', options: {value: this.columnData.label}} : this.columnData.label
        const xAxisLabel = new TextView(labelText, 0, xAxisLabelY, this.columnWidth, this.labelHeight, this, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.White))
        xAxisLabel.centerX()
    }

    private drawXAxisLabelSprite(xAxisLabelY: number) {
        if(this.columnData.texture == undefined) return

        const labelSpriteHeight = this.height * 0.2
        const labelSpriteWidth = labelSpriteHeight / UIGameConstants.CARD_RATIO
        const labelSpriteY = xAxisLabelY - labelSpriteHeight * 0.2
        const xAxisLabelSprite = new SpriteView(0, labelSpriteY, labelSpriteWidth, labelSpriteHeight, this, this.columnData.texture)
        xAxisLabelSprite.centerXInParent()
    }

    private drawColumn() {
        this.removeRoundedBg()

        const columnColor = this.columnData.label === 7 ? GameColor.Color.Gray1 : GameColor.Color.PrimaryBlue5
        const yAxisLabelTopOffset = this.columnHeight * 0.02
        const minimumColumnFillAmountToDrawLabel = 2 * yAxisLabelTopOffset + this.labelHeight

        this.columnFillAmount = this.columnFillAmount > minimumColumnFillAmountToDrawLabel ? this.columnFillAmount : minimumColumnFillAmountToDrawLabel

        const backgroundY = this.columnHeight - this.columnFillAmount

        this.bg = new PIXI.Graphics()
        this.bg.beginFill(GameColor.getColorHexValue(columnColor), 1)
        this.bg.drawRoundedRect(0, backgroundY, this.columnWidth, this.columnFillAmount, this.columnCornerRadius)
        this.bg.endFill()

        this.addChild(this.bg)
        this.drawYAxisLabel(backgroundY, yAxisLabelTopOffset)
    }

    private drawYAxisLabel(backgroundY: number, yAxisLabelTopOffset: number) {
        const yAxisLabelTotalHeight = yAxisLabelTopOffset + this.labelHeight
        const yAxisLabelY = yAxisLabelTotalHeight > this.columnFillAmount ? backgroundY : backgroundY + yAxisLabelTopOffset

        const axisLabelText: TranslationObject = {key: 'strings:colonistCommon.utils.#buffer', options: {value: this.columnData.amount}}
        const yAxisLabel = new TextView(axisLabelText, 0, yAxisLabelY, this.columnWidth, this.labelHeight, this, GameFont.Size.Normal, GameColor.getColor(GameColor.Color.White), true)
        yAxisLabel.centerX()
        yAxisLabel.makeBold()
    }
}
